import {createApiToken, getApiTokenActivity, getApiTokens, revokeApiToken} from '@/api/tokens';
import {useInfiniteQuery, useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import type {CreateApiTokenRequest} from '@/types/api';

export function useApiTokens() {
    return useQuery({
        queryKey: ['apiTokens'],
        queryFn: getApiTokens
    });
}

export function useCreateApiToken() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CreateApiTokenRequest) => createApiToken(data),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['apiTokens']});
        }
    });
}

export function useRevokeApiToken() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => revokeApiToken(id),
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ['apiTokens']});
        }
    });
}

export function useApiTokenActivity(id: string, enabled: boolean) {
    return useInfiniteQuery({
        queryKey: ['apiTokenActivity', id],
        queryFn: ({pageParam}) => getApiTokenActivity(id, pageParam),
        getNextPageParam: page => page.nextCursor || undefined,
        enabled
    });
}
